<app-layout [configurationObj]="configObj" class="bg-white"></app-layout>